export const Endpoints = {
  ChangeSoldListingVisibility: '/listings/sold/change-visibility',
  AddGrowSurfParticipant: '/growsurf/add-participant',
  GetProServiceCategories: '/jobs/service-categories',
  UserProfile: '/user/profile',
  UserGeoLocation: '/user/geolocation',
  UserTags: '/user/tags',
  Events: '/events',
};
